import config from 'config/index';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const CryptoJS = require('crypto-js');

// CREATE SHA256 STRING
export const createHmacString = (privateKey, info) => {
  const key = CryptoJS.enc.Utf8.parse(privateKey);
  const content = CryptoJS.enc.Utf8.parse(info);
  const hmac = CryptoJS.enc.Hex.stringify(CryptoJS.HmacSHA256(content, key));

  return hmac;
};

// CREATE USER IDENTITY
export const createUserIdentity = (user) => {
  const secret = config.REACT_APP_SEGMENT;
  // CURRENT TIMESTAMP
  const now = Math.floor(Date.now() / 1000);
  // USER UNIQUE ID - DATABASE
  const uid = user.id;
  // HASH BASED ON ID AND TIMESTAMP
  const uid_hash = createHmacString(secret, uid);

  const segmentObj = {
    user_id: uid,
    name: user?.fullName,
    email: user?.emailId,
    phone: user?.phoneNo,
    created: user?.createdAt,
    hotel: user?.Hotel?.name,
    username: user?.username,
    industry: user?.Hotel?.Industry?.name,
    team:
      user?.Hotel?.orgSize &&
      `${user?.Hotel?.orgSize?.min || ''} - ${user?.Hotel?.orgSize?.max || ''}`,
    subscription_status: user?.Hotel?.Subscription?.status,
    workspace_id: user?.HotelId,
  };

  window.analytics.identify(uid, segmentObj);
};
